<template>
  <i-box class="metric-unit">
    <span slot="title">
        <div class="unit-title">
          <el-popover
            :content="description"
            ref="popover-hint"
            width="250"
            placement="bottom-end"
            trigger="hover"
          >
            <span
              slot="reference"
              class="fa fa-info-circle pull-right"
            />
          </el-popover>
          <h5>{{ title }}</h5>
        </div>
      </span>

      <span slot="content">
        <bar-chart
          v-if="type === 'bar'"
          class="content-chart"
          :data="chartData"
          :stacked="stacked"
          :showLegend="showLegend"
        />
        <horizontal-bar-chart
          v-if="type === 'horizontal-bar'"
          class="content-chart"
          :data="chartData"
          :stacked="stacked"
          :showLegend="showLegend"
        />
      </span>

  </i-box>
</template>

<script>
import IBox from '@/components/common/IBox';
import BarChart from '@/components/charts/BarChart';
import HorizontalBarChart from '@/components/charts/HorizontalBarChart';

export default {
  name: 'FacebookPageViewsItem',

  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'bar',
    },
    description: {
      type: String,
      default: '',
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    chartData: {
      type: Array,
      required: true,
    },
  },

  components: {
    IBox,
    BarChart,
    HorizontalBarChart,
  },
};
</script>

<style lang="scss" scoped>
.metric-unit {
  width: 550px;
}

.content-chart {
  max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// PageViewsItem.vue?9444dcbe